(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-drawer-overlay]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const instagramUrl = 'https://www.instagram.com/mutena.tr/';

  document.querySelectorAll('[data-instagram-link]').forEach((link) => {
    link.setAttribute('href', instagramUrl);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');

    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const opened = window.open(instagramUrl, '_blank', 'noopener,noreferrer');
      if (!opened) window.location.href = instagramUrl;
    });
  });

  const setDrawer = (drawer, open) => {
    if (!drawer || !overlay) return;

    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.hidden = !open;
    requestAnimationFrame(() => overlay.classList.toggle('is-open', open));
    body.classList.toggle('drawer-open', open);

    if (open) {
      const focusTarget = drawer.querySelector('input, button, a');
      if (focusTarget) focusTarget.focus();
    }
  };

  const closeDrawers = () => {
    setDrawer(mobileMenu, false);
    setDrawer(searchDrawer, false);
    document.querySelectorAll('[data-info-panel].is-open').forEach((panel) => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
  };

  document.querySelector('[data-mobile-menu-open]')?.addEventListener('click', () => setDrawer(mobileMenu, true));
  document.querySelector('[data-mobile-menu-close]')?.addEventListener('click', closeDrawers);
  document.querySelector('[data-search-open]')?.addEventListener('click', () => setDrawer(searchDrawer, true));
  document.querySelector('[data-search-close]')?.addEventListener('click', closeDrawers);
  overlay?.addEventListener('click', closeDrawers);

  const openInfoPanel = (panelId, event) => {
    if (!overlay) return false;
    const panel = document.getElementById(panelId);
    if (!panel?.matches('[data-info-panel]')) return false;

    event?.preventDefault();
    closeDrawers();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    body.classList.add('drawer-open');
    panel.focus();
    return true;
  };

  document.querySelectorAll('[data-info-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const panelId = trigger.dataset.infoOpen;
      openInfoPanel(panelId, event);
    });
  });

  document.querySelectorAll('a[href^="#mutena-"]:not([data-info-open])').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const panelId = trigger.getAttribute('href')?.slice(1);
      const panel = document.getElementById(panelId);
      if (!panel) return;

      openInfoPanel(panelId, event);
      history.replaceState(null, '', `#${panelId}`);
    });
  });

  document.querySelectorAll('[data-info-close]').forEach((close) => {
    close.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawers();
      overlay?.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      body.classList.remove('drawer-open');
      if (window.location.hash.startsWith('#mutena-')) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    });
  });

  if (window.location.hash.startsWith('#mutena-')) {
    openInfoPanel(window.location.hash.slice(1));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  const header = document.querySelector('[data-site-header]');
  if (header?.classList.contains('site-header--transparent')) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 80);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;

    let activeIndex = 0;
    let timer;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const startAutoplay = () => {
      if (slider.dataset.autoplay !== 'true') return;
      const interval = Number(slider.dataset.interval) || 6000;
      clearInterval(timer);
      timer = setInterval(() => showSlide(activeIndex + 1), interval);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.heroDot));
        startAutoplay();
      });
    });

    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', startAutoplay);
    startAutoplay();
  });

  document.querySelectorAll('[data-product-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track) return;

    const scrollAmount = () => Math.min(track.clientWidth * 0.82, 900);
    previous?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantsJson = root.querySelector('[data-product-variants-json]');
    const optionInputs = [...root.querySelectorAll('[data-option-input]')];
    const variantIdInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    if (!variantsJson || !optionInputs.length || !variantIdInput || !addButton) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const getSelectedOptions = () => {
      const selected = [];
      optionInputs.forEach((input) => {
        if (input.checked) selected[Number(input.dataset.optionIndex)] = input.value;
      });
      return selected;
    };

    const findVariant = (options) => variants.find((variant) =>
      variant.options.every((value, index) => value === options[index])
    );

    const updateOptionAvailability = (selectedOptions) => {
      optionInputs.forEach((input) => {
        const optionIndex = Number(input.dataset.optionIndex);
        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = input.value;
        const possible = variants.some((variant) =>
          variant.available && variant.options.every((value, index) => value === testOptions[index])
        );
        const label = input.closest('.variant-option');
        input.disabled = !possible && !input.checked;
        label?.classList.toggle('is-unavailable', !possible);
      });
    };

    const updateSelectedLabels = (selectedOptions) => {
      selectedOptions.forEach((value, index) => {
        const label = root.querySelector(`[data-selected-option="${index}"]`);
        if (label) label.textContent = value;
      });

      optionInputs.forEach((input) => {
        input.closest('.variant-option')?.classList.toggle('is-selected', input.checked);
      });
    };

    const updateProductForm = () => {
      const selectedOptions = getSelectedOptions();
      const variant = findVariant(selectedOptions);
      updateSelectedLabels(selectedOptions);
      updateOptionAvailability(selectedOptions);

      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.unavailableText || 'Seçenek Yok';
        return;
      }

      variantIdInput.value = variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (price) {
        price.innerHTML = `<span>${variant.price}</span>${variant.compare_at_price ? `<s>${variant.compare_at_price}</s>` : ''}`;
      }

      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? (addButton.dataset.addToCartText || 'Sepete Ekle')
        : (addButton.dataset.soldOutText || 'Tükendi');

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({ path: url.toString() }, '', url.toString());
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateProductForm));
    updateProductForm();
  });

  const storageKey = 'mutena-favorites';
  let favorites = [];

  try {
    favorites = JSON.parse(localStorage.getItem(storageKey) || '[]');
  } catch (error) {
    favorites = [];
  }

  document.querySelectorAll('[data-favorite]').forEach((button) => {
    const handle = button.dataset.favorite;
    const updateButton = () => {
      const active = favorites.includes(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    };

    updateButton();

    button.addEventListener('click', () => {
      favorites = favorites.includes(handle)
        ? favorites.filter((favorite) => favorite !== handle)
        : [...favorites, handle];

      try {
        localStorage.setItem(storageKey, JSON.stringify(favorites));
      } catch (error) {
        // Favorites still work for the current page when storage is unavailable.
      }

      updateButton();
    });
  });

  document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
    event.target.closest('form')?.submit();
  });
})();
